var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasurmentCar2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1222,
    height: 618,
    viewBox: "0 0 1222 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.759 395.581V404.422C102.759 404.422 73.3725 406.372 44.9305 401.295C16.4884 396.218 2.41203 389.886 1.00439 387.377C1.40933 385.89 2.68199 378.864 2.68199 378.864C2.68199 378.864 6.63495 262.673 7.67622 256.727C8.71749 250.781 19.9786 246.824 19.9786 246.824C19.9786 246.824 20.48 221.304 35.077 209.992C41.5946 188.757 67.8576 175.901 105.575 165.998C143.292 156.095 175.205 150.632 185.386 146.617C190.361 144.667 203.415 139.822 217.145 132.467C231.549 124.726 246.686 114.36 254.341 108.51C271.753 95.2293 355.113 38.4947 355.113 38.4947L375.629 26.6999C375.629 26.6999 412.749 10.0019 464.446 5.13729C516.143 0.272673 571.137 1.04483 571.137 1.04483L761.111 3.03315L975.188 5.56198C975.188 5.56198 1149.46 7.58891 1173.92 7.97499C1198.37 8.36107 1201.28 30.4063 1201.28 30.4063C1201.28 30.4063 1205.17 62.7599 1209.32 92.8163C1213.46 122.873 1211.38 135.942 1211.38 135.942L1207.78 135.247C1207.78 135.247 1219.56 159.589 1219.56 191.17C1219.56 222.752 1215.7 289.602 1215.7 289.602C1215.7 289.602 1220.87 304.987 1220.87 318.616C1220.87 332.244 1213.62 340.449 1213.62 340.449C1213.62 340.449 1219.71 342.186 1219.71 353.073V377.184C1219.71 377.184 1220.06 389.886 1204.11 393.071C1188.17 396.257 1081.57 403.534 1081.57 403.534C1081.57 403.534 1076.29 404.885 1076.29 395.272C1076.29 385.659 1075.73 384.018 1075.73 384.018C1075.73 384.018 1075.28 279.93 973.741 279.93C872.198 279.93 874.146 387.782 874.146 387.782C872.7 393.206 873.895 402.859 873.895 402.859L835.195 403.515L547.034 404.75L305.382 405.909V396.392C305.382 396.392 306.694 281.648 203.396 281.648C100.098 281.648 102.663 395.523 102.663 395.523L102.759 395.581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2242 265.182L32.0494 267.46C26.0332 267.923 21.1739 272.556 20.4026 278.541L7.69531 380.64",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2242 265.182L32.0494 267.46C26.0332 267.923 21.1739 272.556 20.4026 278.541L7.69531 380.64",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19806 376.74C8.19806 376.74 1.83475 383.13 1.00559 388.149C0.619938 390.446 20.2305 397.145 43.3505 401.005C70.8477 405.6 102.664 404.422 102.664 404.422C102.664 353.595 112.363 281.687 203.494 281.687C294.624 281.687 305.48 362.976 305.48 405.947",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.493 469.901C250.872 469.901 289.281 431.45 289.281 384.018C289.281 336.585 250.872 298.134 203.493 298.134C156.113 298.134 117.704 336.585 117.704 384.018C117.704 431.45 156.113 469.901 203.493 469.901Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.493 437.915C233.227 437.915 257.331 413.784 257.331 384.018C257.331 354.252 233.227 330.121 203.493 330.121C173.76 330.121 149.656 354.252 149.656 384.018C149.656 413.784 173.76 437.915 203.493 437.915Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.515 469.901C1021.89 469.901 1060.3 431.45 1060.3 384.018C1060.3 336.585 1021.89 298.134 974.515 298.134C927.135 298.134 888.726 336.585 888.726 384.018C888.726 431.45 927.135 469.901 974.515 469.901Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.516 437.915C1004.25 437.915 1028.35 413.784 1028.35 384.018C1028.35 354.252 1004.25 330.121 974.516 330.121C944.783 330.121 920.679 354.252 920.679 384.018C920.679 413.784 944.783 437.915 974.516 437.915Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.648 186.402L34.1341 210.281C34.1341 210.281 21.5424 222.211 19.2285 247.094C28.7542 247.673 54.3231 244.739 71.4847 241.457C80.644 239.701 88.415 233.639 92.4065 225.203L110.667 186.422L110.648 186.402Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1137.41 30.4065H595.994C585.253 30.4065 577.945 41.294 582.014 51.2356L613.271 127.873C622.064 149.435 642.928 163.604 666.183 163.817L1141.85 168.199C1156.41 168.334 1168.02 156.018 1167.01 141.463L1160.94 52.3938C1160.09 40.0006 1149.81 30.3872 1137.4 30.3872L1137.41 30.4065Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.481 405.945L873.994 402.876",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.752 144.416C460.244 152.813 348.327 172.639 247.826 182.677C242.137 183.063 233.267 180.611 249.176 166.307C265.084 152.003 354.691 70.0182 413.368 52.2006C449.832 41.1394 494.066 43.0891 513.06 43.4173C517.109 43.4945 520.214 46.9692 519.732 50.9072L510.11 132.061C509.396 138.123 504.845 143.065 498.752 144.397V144.416Z",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.481 176.597L350.468 173.527C356.774 173.103 361.787 168.064 362.192 161.752L364.506 126.097C364.776 121.908 361.459 118.356 357.256 118.356H348.598C341.791 118.356 335.196 120.634 329.816 124.823L328.987 125.48C323.087 130.093 319.654 137.197 319.731 144.687L319.886 161.636L305.481 164.628",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.481 176.597L350.468 173.527C356.774 173.103 361.787 168.064 362.192 161.752L364.506 126.097C364.776 121.908 361.459 118.356 357.256 118.356H348.598C341.791 118.356 335.196 120.634 329.816 124.823L328.987 125.48C323.087 130.093 319.654 137.197 319.731 144.687L319.886 161.636L305.481 164.628",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.717 176.981L227.963 187.212C226.806 187.366 226.131 185.918 227.018 185.146L297.709 123.914C299.309 122.524 301.816 123.624 301.855 125.748L303.012 174.278C303.05 175.629 302.067 176.788 300.717 176.981Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.475 198.39C510.27 198.39 515.778 192.876 515.778 186.074C515.778 179.272 510.27 173.758 503.475 173.758C496.681 173.758 491.173 179.272 491.173 186.074C491.173 192.876 496.681 198.39 503.475 198.39Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.806 182.271H481.147C479.049 182.271 477.349 183.973 477.349 186.073V186.093C477.349 188.193 479.049 189.896 481.147 189.896H525.806C527.904 189.896 529.605 188.193 529.605 186.093V186.073C529.605 183.973 527.904 182.271 525.806 182.271Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.211 18.8633H563.637V404.423H862.211V18.8633Z",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.874 213.196H839.34",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.154 189.897L206.888 168.624C234.424 150.363 334.79 51.4487 408.335 30.4073C458.489 16.0451 516.954 18.9407 542.928 19.4233C548.462 19.5198 552.705 24.3072 552.068 29.7317L549.696 213.699C549.079 238.833 521.717 246.864 516.8 286.321C511.883 325.779 508.971 353.325 508.971 353.325",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.769 213.679C329.198 216.883 104.979 240.84 104.979 240.84",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2084 247.094L16.4896 249.391C11.2447 250.897 7.54236 255.607 7.31097 261.07L2.72168 383.458",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5843 246.805C30.5843 246.805 20.808 255.337 21.2515 275.336",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1333 210.282C34.1333 210.282 41.9428 192.753 66.7211 179.337C82.8801 170.592 136.582 157.601 172.024 149.609C195.028 144.416 216.837 134.841 236.178 121.328C267.03 99.7852 309.221 69.0724 338.781 47.78C368.342 26.4877 409.24 11.4884 447.092 6.9713C475.091 3.6317 513.174 1.00635 563.637 1.00635C606.773 1.00635 1074.05 6.73965 1177.46 8.01372C1189.25 8.16815 1199.18 16.7584 1201.03 28.3988C1205.19 54.6909 1211.75 101.31 1211.75 135.169H1184.83V339.02H1211.75C1211.75 339.02 1219.81 339.599 1219.81 353.074V376.045C1219.81 384.906 1213.02 392.299 1204.21 393.052L1081.67 403.515C1079.05 403.747 1076.81 401.7 1076.73 399.075C1075.67 355.12 1059.67 279.66 974.803 279.66C894.356 279.66 873.974 343.692 873.974 402.395",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.49 135.169C1208.49 135.169 1219.81 165.727 1219.81 198.216C1219.81 230.705 1215.78 289.582 1215.78 289.582H1184.81",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.78 289.602C1215.78 289.602 1220.99 305.412 1220.99 316.009C1220.99 339.116 1213.7 339.638 1213.7 339.638",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.903 364.154H364.254C357.756 364.154 351.393 365.969 345.878 369.385L340.537 372.686C338.955 373.671 339.65 376.103 341.501 376.103H835.794C839.4 376.103 840.731 371.374 837.665 369.482C832.034 365.988 825.536 364.135 818.903 364.135V364.154Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.584 200.36H1146.32C1151.7 200.36 1156.06 204.723 1156.06 210.108V214.683C1156.06 220.069 1151.7 224.432 1146.32 224.432H879.584V200.36Z",
    fill: "white",
    stroke: "#0E2C49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.498 498.258L512.958 498.258",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71387 498.258L44.5706 498.258",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M162.212 498.258L197.069 498.258",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M985.703 498.258L1037.99 498.258",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1159.99 498.258L1212.27 498.258",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.783 380.486L205.783 498.257",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "1 2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M658.921 498.258L968.274 498.258",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M976.988 384.847L976.988 498.257",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M937.775 101.324L1142.56 101.324",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M589.208 101.324L793.991 101.324",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20752 616.028L497.707 616.028",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1 376.124L0.999995 616.028",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M676.35 616.028L1220.98 616.029",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1220.99 376.124L1220.99 616.028",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5 5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M698.134 48.981L698.134 219.095",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M698.134 295.429L698.134 353.039",
    stroke: "#3078FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurmentCar2);
export default __webpack_public_path__ + "static/media/measurment-car-2.e7fedb2cb8661b72644d18c44d705162.svg";
export { ForwardRef as ReactComponent };